import { ApplicationError } from '../src/applicationError.mjs';

export default function formatAddress(adr) {
    if ( ! (adr.street || adr.district || adr.postcode) ) {
        throw new ApplicationError('too many missing address components');
    }
    const parts = [];
    if (adr.street) {
        parts.push(adr.houseno ? adr.street + ' ' + adr.houseno : adr.street);
    }
    if (adr.district) {
        parts.push(adr.district);
    }
    if (adr.postcode) {
        parts.push(adr.postcode);
    }
    return parts.join(', ');
}
